export default __webpack_public_path__ + "static/media/Broker.73c57702.svg";